module.exports = __webpack_public_path__ + "static/ftswhite.2f76b41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ftswhite.png
// module id = 318
// module chunks = 79611799117203